export const HC_ARTICLE = "https://support.oysterhr.com/hc/en-us/articles/4405832294289"
